<ion-content class="app embed">
  <app-loader
    [full]="true"
    [loading]="loading()"
  ></app-loader>
  @if (!loading()) {
    <div
      class="embed__header"
      [class.dark]="theme() === 'dark'"
    >
      @if (header() === 'show' && coverImageUrl()) {
        <div
          class="embed__header__cover"
          [style.background-image]="'url(' + coverImageUrl() + ')'"
        ></div>
      }
      <div class="embed__header__info">
        <div class="embed__image">
          <img
            appImgFallback
            [src]="logoUrl()"
            width="48"
            height="48"
            [alt]="name()"
          />
        </div>
        <div class="embed__info">
          <h1>{{ name() }}</h1>
          @for (line of metaLines(); track line) {
            <span>{{ line }}</span>
          }
        </div>
        <div class="embed__about">
          @if (info() === 'show' && infoComponent()) {
            <button
              type="button"
              (click)="showInfo()"
              class="button button-info"
              [attr.aria-label]="'button.info' | translate"
            >
              <ion-icon
                aria-hidden="true"
                size="large"
                [icon]="'information-circle'"
              ></ion-icon>
            </button>
          }
        </div>
      </div>
    </div>
    <div class="embed__content">
      @if (updates()) {
        <app-update-list
          [updates]="updates()"
          [project]="project()"
          [customer]="customer()"
        ></app-update-list>
      }
    </div>
  }
</ion-content>
